import { z } from "zod";

/**
 * A saved Find-Person waterfall preset. `config` is stored opaque on the backend; on the web it
 * holds `{ enrichmentFilterConfig, maxPerCompany }` (see SearchProfilePresetConfig below).
 */
export const SearchProfilePresetSchema = z.object({
	id: z.number(),
	name: z.string(),
	config: z.record(z.string(), z.unknown()),
	companyId: z.number(),
	createdAt: z.string(),
	updatedAt: z.string(),
});

export const SearchProfilePresetListResponseSchema = z.object({
	data: z.array(SearchProfilePresetSchema),
});

export const SearchProfilePresetDeleteResponseSchema = z.object({
	success: z.boolean(),
});

export type SearchProfilePreset = z.infer<typeof SearchProfilePresetSchema>;
export type SearchProfilePresetListResponse = z.infer<typeof SearchProfilePresetListResponseSchema>;
export type SearchProfilePresetDeleteResponse = z.infer<
	typeof SearchProfilePresetDeleteResponseSchema
>;
